import { useMemo } from 'react';

import { MarkdownPreview } from '@/components/markdown/MarkdownPreview';
import { MAIN_TAB_DEFS } from '@/sections/POE';

interface TabDescriptionProps {
  tabId: string;
  definitionsFileValue?: string;
}

/**
 * TabDescription - Description component for POE tabs
 *
 * Displays vulnerability description content directly without collapse/expand.
 * Content is always visible - no "Read More" step required.
 */
export function TabDescription({
  tabId,
  definitionsFileValue = '',
}: TabDescriptionProps) {
  const tab = Object.values(MAIN_TAB_DEFS).find(tab => tab.id === tabId);

  const markdown = useMemo(() => {
    if (
      (tabId !== 'overview' && tabId !== 'information') ||
      !definitionsFileValue
    ) {
      return '';
    }
    let markdownValue = definitionsFileValue.trim().split('#### References')[0];
    const descriptionParts = markdownValue.split(
      '#### Vulnerability Description'
    );
    if (descriptionParts.length > 1) {
      markdownValue = descriptionParts[1].trim();
    } else {
      markdownValue = markdownValue.trim();
    }

    return markdownValue;
  }, [definitionsFileValue, tabId]);

  if (
    (tabId !== 'overview' && tabId !== 'information') ||
    !definitionsFileValue
  ) {
    return tab?.description || '';
  }

  return (
    <div data-testid="tab-description-content">
      <MarkdownPreview
        source={markdown}
        className="break-words *:w-full"
        thumbnail={true}
        processVulnerabilityContent={true}
      />
    </div>
  );
}
